import React from 'react';

const PageHeader = () => {
  return (
    <section
      className="relative pt-28 pb-20 md:pt-32 md:pb-28 min-h-[480px] flex items-center"
      style={{
        backgroundImage: `url('/storage/gallery_images/slider-3.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Navy overlay with brand color */}
      <div className="absolute inset-0 bg-blue-900/70"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Headline */}
        <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-white mb-6 drop-shadow-lg">
          Meet Your Eye Care
        </h1>

        {/* Subheading */}
        <p className="text-lg md:text-xl lg:text-2xl text-white/95 mb-10 leading-relaxed drop-shadow-md max-w-3xl mx-auto">
          Our internationally trained specialists combine world-class medical expertise
          with genuine compassion, cultural understanding, and a deep commitment to
          transforming lives through better vision.
        </p>
      </div>
    </section>
  );
};

export default PageHeader;
